import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const styles = () => {
  return {
    container: {
      position: 'fixed',
      top: 'calc(20vh - 20px)',
      left: 0,
      right: 0,
      bottom: 0,
      width: 'auto',
      padding: '0 15px',
    },
    containerAdjust: {
      position: 'fixed',
      top: 'calc(20vh - 35px)',
      left: 0,
      right: 0,
      bottom: 0,
      width: 'auto',
      padding: '0 15px',
    },
    backgroundOverlay: {
      backgroundColor: '#fafafa',
      position: 'fixed',
      top: '20vh',
      left: 0,
      right: 0,
      bottom: 0,
      width: 'auto',
      padding: '0',
    },
    scrollable: {
      overflowY: 'scroll',
    },
  }
}

@injectSheet(styles)
class MobileContent extends Component {
  static defaultProps = {
    adjust: false,
    scrollable: true,
  }

  ref = null

  render() {
    const {
      classes, children, adjust, scrollable,
    } = this.props
    return (
      <div
        className={classNames({
          [classes.containerAdjust]: adjust,
          [classes.container]: !adjust,
          [classes.scrollable]: scrollable,
        })}
        id={'mobile-content'}
      >
        <div>{children}</div>
      </div>
    )
  }
}

MobileContent.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.object,
  children: PropTypes.node,
  adjust: PropTypes.bool,
  scrollable: PropTypes.bool,
}

export default MobileContent
